export const hasAuthorizationParams = query =>
  ['response_type', 'client_id', 'redirect_uri', 'state'].every(key =>
    query.has(key)
  )



// WEBPACK FOOTER //
// ./src/utils/auth.js